import React, { useEffect, useState, useContext } from "react";
import {
  Box, Typography, CircularProgress, useTheme, Button, TextField
} from "@mui/material";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { tokens } from "../../theme";
import { learncardsContext } from "../../App";
import { API, Auth } from "aws-amplify";
import ReactQuill from 'react-quill'; // Import react-quill
import 'react-quill/dist/quill.snow.css'; // Import react-quill stylesheet

const Cards = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { loading, setLoading, cardData, setCardData, selectedOption, setSelectedOption } = useContext(learncardsContext);
  const [newSetName, setNewSetName] = useState(""); // State to store the name for the new JS
  const [numCards, setNumCards] = useState(1); // State to store the number of cards to add
  const [searchText, setSearchText] = useState(""); // State to store the search text


  const handleProcessRowUpdate = async (updatedRow, oldRow) => {
    console.log("Updating row:", updatedRow);
    const updatedCardData = cardData.data.map((item) => {
      if (item.id === updatedRow.id) {
        return { ...item, ...updatedRow };
      }
      return item;
    });
    setCardData({ ...cardData, data: updatedCardData });
    updateBackend(updatedRow.id, updatedRow);
    return updatedRow;
  };

  const handleProcessRowUpdateError = (error) => {
    console.error("Process row update error:", error);
  };

  const generateRandomString = (length) => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
  };

  const handleAddRows = () => {
    const newRows = [];
    for (let i = 0; i < numCards; i++) {
      const emptyRow = {
        id: generateRandomString(8),
        nr: getHighestNr() + i + 1,
        front: "TYP HIER",
        back1: "",
        back2: "",
        back3: "",
        hit: "",
        mis: "",
        hit_date: ""
      };
      newRows.push(emptyRow);
    }

    setCardData(prevCardData => ({
      ...prevCardData,
      data: [...newRows, ...prevCardData.data]
    }));
  };

  const getHighestNr = () => {
    let highestNr = 0;
    cardData.data.forEach((item) => {
      const nr = parseInt(item.nr);
      if (!isNaN(nr) && nr > highestNr) {
        highestNr = nr;
      }
    });
    return highestNr;
  };

  const handleDeleteRow = async (rowId) => {
    const updatedRows = cardData.data.filter((item) => item.id !== rowId);
    setCardData({ ...cardData, data: updatedRows });
    try {
      const session = await Auth.currentSession();
      const accessToken = session.getAccessToken().getJwtToken();
      const headers = {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      };
      const route = `/deleteCard?id=${rowId}&selectie=${selectedOption}`;
      const response = await API.del("FRONTEND_HTTP_API", route, {
        headers: headers,
      });
      console.log("Delete successful:", response);
    } catch (error) {
      console.error("Error deleting the card:", error);
    }
  };


  const handleCreateSetClick = async () => {
    try {
      const session = await Auth.currentSession();
      const accessToken = session.getAccessToken().getJwtToken();
      const headers = {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      };
      const route = "/createSet"; // API route for creating a new JSON file
      const response = await API.post("FRONTEND_HTTP_API", route, {
        body: { name: newSetName }, // Send the name for the new JSON file
        headers: headers,
      });
      console.log("Create set successful:", response);
      setSelectedOption(newSetName);
    } catch (error) {
      console.error("Error creating set:", error);
    }
  };



  const updateBackend = async (id, updatedItem) => {
    const session = await Auth.currentSession();
    const accessToken = session.getAccessToken().getJwtToken();
    const headers = {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    };
    try {
      const route = `/updateCard?selectie=${selectedOption}`;
      const response = await API.post("FRONTEND_HTTP_API", route, {
        body: updatedItem,
        headers: headers,
      });
      console.log("Update successful:", response);
    } catch (error) {
      console.error("Error updating the backend:", error);
    }
  };

  if (!cardData || !cardData.data) {
    return <CircularProgress />;
  }

  const renderHtmlCell = (params) => {
    return (
      <div dangerouslySetInnerHTML={{ __html: params.value }} />
    );
  };

  const columns = [
    {
      field: 'nr',
      headerName: 'Nr',
      flex: 0.5,
      editable: true,
      valueGetter: (params) => {
        const value = params.value;
        const parsed = parseInt(value, 10);
        return isNaN(parsed) ? null : parsed;
      },
      sortComparator: (v1, v2) => {
        // Handle nulls (missing or NaN) so they always sort last
        if (v1 === null && v2 === null) return 0;
        if (v1 === null) return 1;
        if (v2 === null) return -1;
        return v1 - v2;
      },
    },
    { field: 'front', headerName: 'Voorkant', flex: 1, editable: true, renderCell: renderHtmlCell },
    { field: 'back1', headerName: 'Achterkant (1)', flex: 1, editable: true, renderCell: renderHtmlCell },
    { field: 'back2', headerName: 'Achterkant (2)', flex: 1, editable: true, renderCell: renderHtmlCell },
    { field: 'back3', headerName: 'Achterkant (3)', flex: 1, editable: true, renderCell: renderHtmlCell },
    // {
    //   field: 'calculatedValue',
    //   headerName: 'Calculated Value',
    //   flex: 0.8,
    //   editable: false,
    //   valueGetter: (params) => {
    //     let hit = parseFloat(params.row.hit);
    //     let mis = parseFloat(params.row.mis);

    //     if (isNaN(hit)) {
    //       hit = 0;
    //     }
    //     if (isNaN(mis)) {
    //       mis = 0;
    //     }

    //     return (hit + mis) !== 0 ? ((hit - mis) / (hit + mis)).toFixed(2) : NaN;
    //   }
    // },
    {
      field: 'delete',
      headerName: '',
      flex: 0.3,
      renderCell: (params) => (
        <Typography
          variant="outlined"
          color="error"
          onClick={() => handleDeleteRow(params.row.id)}
        >
          🗑️
        </Typography>
      ),
    },
  ];

  const rows = cardData.data.map((item) => ({
    id: item.id,
    ...item,
  }));

  const filteredRows = rows.filter((row) => {
    return Object.values(row).some((value) =>
      String(value).toLowerCase().includes(searchText.toLowerCase())
    );
  });

  return (
    <Box m="20px">
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography variant="h6" sx={{ mr: 2 }}>
            Kies aantal kaarten:
          </Typography>
          <TextField
            type="number"
            value={numCards}
            onChange={(e) => setNumCards(Math.max(1, parseInt(e.target.value) || 1))}
            inputProps={{ min: 1 }}
            sx={{ width: '80px', mr: 2 }}
          />
          <Button variant="contained" onClick={handleAddRows}>
            Toevoegen Kaart{numCards > 1 ? 'en' : ''}
          </Button>
        </Box>
        <TextField
          label="Zoeken"
          variant="outlined"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          sx={{ ml: 2 }}
        />
      </Box>
      {loading ? (
        <CircularProgress />
      ) : (
        filteredRows.length > 0 && (
          <Box sx={{ flexGrow: 1, width: '100%' }}>
            <DataGrid
              rows={filteredRows}
              columns={columns}
              disableSelectionOnClick
              //hideFooter="True"
              processRowUpdate={handleProcessRowUpdate}
              onProcessRowUpdateError={handleProcessRowUpdateError}
              pageSizeOptions={[5, 10, 25]}
              sx={{
                '& .MuiDataGrid-main': { width: '100%' },
                '& .MuiDataGrid-cell': { maxWidth: 'unset !important', fontWeight: '600' }, // Increased font weight for regular content
                '& .MuiDataGrid-columnHeaders': {
                  maxWidth: 'unset !important',
                  backgroundColor: 'rgb(223, 84, 42,0.7)',
                  color: 'black',
                  //fontSize: '1.0rem',
                  //make font super bold with extra font weight
                  fontWeight: 'bold',
                  fontSize: '1.0rem',
                },
                '& .MuiDataGrid-columnHeader': {
                  borderRight: `1px solid ${colors.primary[200]}`,
                },
                '& .MuiDataGrid-columnHeaderTitle': {
                  padding: '0 16px',
                },
              }}
            />
          </Box>
        )
      )}
    </Box>
  );
};



export default Cards;